/**
 * Mac App Store CTA card — S5-T4.1. The dominant CTA on the funnel.
 *
 * Replaced the pre-launch DemandCaptureCard once the App Store listing was
 * ready. Anchor copy from S5-T1.2: category language only (never Adobe by
 * name, locked 2026-05-26), US-only qualified currency.
 * Click destination comes from app-store-url.ts so the placeholder App ID
 * is a one-line swap when Apple assigns the real one.
 */

import styles from "./MacAppStoreCard.module.css";
import { getMacAppStoreHref } from "../app-store-url";

export function MacAppStoreCard() {
  return (
    <section className={styles.card} aria-label="Get Imprint for Mac">
      {/* Category language only, never name Adobe (locked 2026-05-26). Sourced
          figure behind "~$240/year": Adobe Acrobat Pro individual, annual
          billing, US$19.99/mo x 12 = US$239.88/yr (stable 2024 to May 2026). */}
      <p className={styles.headline}>Stop paying about $240 a year for a PDF subscription.</p>
      <p className={styles.priceContrast}>
        <span className={styles.priceOld}>~$240/year</span>
        <span className={styles.priceNew}>US$29.99, yours forever</span>
      </p>
      <p className={styles.value}>
        No subscription. Stamps stay on your Mac. Number every file in one pass.
      </p>

      <a className={styles.primary} href={getMacAppStoreHref()}>
        Get Imprint for Mac
      </a>

      <p className={styles.privacy}>On the Mac App Store. One-time purchase.</p>
    </section>
  );
}
